import { gql } from "@apollo/client";

export const GET_BANK_ACCOUNTS = gql`
query BankAccounts{
    bankAccounts{
        bankAccounts {
            id,
            aff {
                id
            },
            currencyId,
            bank {
                id,
                name,
                imageUrl
            },
            accountName,
            accountNumber,
            bankBranch,
            withdrawMethodId,
            withdrawMethod{
                name,
                iconUrl
            }
        }
    }
}
`

export const GET_AFF_BANK_ACCOUNT = gql`
query AffiliateBankAccount($id:String!){
    affiliateBankAccount(id:$id){
        id,
        aff {
            id,
            userName,
            name
        },
        currencyId,
        bank {
            id,
            name
        }
        accountName,
        accountNumber,
        bankBranch,
        withdrawMethod{
            name
        }
    }
}
`;

export const GET_BANKS = gql`
query Banks{
    banks{
        id,
        name
    }
}
`;

export const EDIT_AFF_BANK_ACCOUNT = gql`
mutation EditAffiliateBankAccount($affiliateBankAccountEditInput:AffiliateBankAccountEditInput!){
    editAffiliateBankAccount(affiliateBankAccountEditInput:$affiliateBankAccountEditInput){
        status,
        id,
        errorMessage
    }
}
`;

export const ADD_BANK = gql`
    mutation CreateBankAccount($createBankAccountInput: CreateBankAccountInput!) {
        createBankAccount(createBankAccountInput: $createBankAccountInput) {
            status
            id,
        }
    }
`;
